import React from "react";

export const DecarbonizationProfile = ({ url }) => {
  if (url) {
    return (
      <iframe
        title="Simulador de descarbonização"
        height="100%"
        width="100%"
        style={{ border: "none" }}
        src={url}
      />
    )
  } else return null;
}
